import BaseService from '../../base/base_service';
import WebLoginServiceDependenciesFactory from './web_login_service_dependencies_factory';
import _ from '../../utils/underscore';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';

export default class WebLoginService extends BaseService {
    static CLASS = 'WebLoginService';

    init(params) {
        super.init(params);

        this._sdkUrl = params.sdkUrl;
        if (!_.isNullOrUndefined(params.enableCaptcha)) {
            this._enableCaptcha = params.enableCaptcha;
        }
        this._dependenciesFactory = params.dependenciesFactory || WebLoginServiceDependenciesFactory.create();
        Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, this._createWebLoginComponent, this);
    }

    _sdkUrl = null;
    _enableCaptcha = true;
    _dependenciesFactory = null;
    _webLoginComponent = null;
    _latestOpenLoginParams = {};

    get _eventsObjectBuilder() {
        return this._dependenciesFactory.createEventsObjectBuilder({
            serviceFactory: this.serviceFactory
        });
    }

    get _initObjectBuilder() {
        return this._dependenciesFactory.createInitObjectBuilder({
            serviceFactory: this.serviceFactory,
            enableCaptcha: this._enableCaptcha
        });
    }

    get _loginErrorHandler() {
        return this._dependenciesFactory.createLoginErrorHandler({
            serviceFactory: this.serviceFactory
        });
    }

    _createWebLoginComponent() {
        this._webLoginComponent = this._dependenciesFactory.createWebLoginComponent({
            sdkUrl: this._sdkUrl,
            initObjectBuilder: this._initObjectBuilder,
            eventsObjectBuilder: this._eventsObjectBuilder,
            serviceFactory: this.serviceFactory
        });
    }

    _openLoginFormPromisesResolvers = [];

    openLoginForm(params) {
        return this.serviceFactory.oAuth2Service().tryToRememberMe().catch(() => {
            return this.serviceFactory.regulationService().stepsBeforeOpenLoginAndRegistration().then(()=> {
                this._latestOpenLoginParams = {};
                if (params) {
                    this._latestOpenLoginParams.marketingParams = params.marketingParams;
                    this._latestOpenLoginParams.onCloseCallback = params.onCloseCallback;
                }

                return new Promise((resolve, reject) => {
                    this._openLoginFormPromisesResolvers.push({
                        resolve: resolve,
                        reject: reject
                    });

                    this._webLoginComponent.show().then(() => {
                        Event.fire(SYSTEM_EVENTS.LOGIN_FORM_OPEN);
                        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_LoginPopup', action: 'Open'});
                    }).catch(err => {
                        this._openLoginFormPromisesResolvers = [];
                        reject(err);
                    });
                });
            });
        });

    }

    /**
     * Change the login form mode type, currently use only for fit-to-play on ontario
     * @param type: WEB_LOGIN_MODES[type]
     */
    updateLoginFormModeType(type){
        this._webLoginComponent.show( { mode: { type } })
    }

    getWebLoginMarketingParams() {
        return this._latestOpenLoginParams.marketingParams;
    }

    closeLoginForm() {
        return this._webLoginComponent.hide().then(() => {
            if (this._latestOpenLoginParams.onCloseCallback) {
                this._latestOpenLoginParams.onCloseCallback();
            }

            if (this.serviceFactory.oAuth2Service().isAuthorized()) {
                this._openLoginFormPromisesResolvers.forEach(promiseResolver => promiseResolver.resolve());
            } else {
                this._openLoginFormPromisesResolvers.forEach(promiseResolver => promiseResolver.reject());
            }

            this._openLoginFormPromisesResolvers = [];

            Event.fire(SYSTEM_EVENTS.LOGIN_FORM_CLOSE)
        });
    }

    processLoginResponse(loginResponse) {
        let originalLoginResponse = loginResponse.data && loginResponse.data.originalLoginResponse;
        return this._webLoginComponent.processResponse(originalLoginResponse)
            .then(loginProcessingResult => {
                if (_.isArray(loginProcessingResult.actionhandler)) {
                    if (loginProcessingResult.actionhandler.filter(ah => ah === 'caller').length > 0) {
                        this._loginErrorHandler.handleError({
                            loginProcessingResult: loginProcessingResult,
                            loginResponse: loginResponse
                        });
                    }
                }
            });
    }

    getDeviceUUID() {      
        return this._webLoginComponent.getDeviceUUID()
            .catch(err => {
                this.logger.error('WebLoginComponent.getDeviceUUID failed', err);
                
                return null; 
            });
    }
}